module.exports = __webpack_public_path__ + "software-cycle.LiAsolgs.svg";